import {
  IconAccessorialsPublish,
  IconBeer,
  IconCFS,
  IconDunnage,
  IconEyeSlash,
  IconLiftGate,
  IconLumper,
  IconMAAC,
  IconPallet,
  IconStopwatch,
  IconTSA,
  IconTarp,
  IconTeamDriver,
  IconTicket,
  IconTruckDropTrailer,
  IconTruckVentilated,
} from '@loadsmart/icons'

export const REQUIREMENTS = {
  beer: { label: 'Beer', icon: <IconBeer />, order: 1 },
  drop_trailer: { label: 'Drop Trailer', icon: <IconTruckDropTrailer />, order: 2 },
  live_load: { label: 'Live Load', icon: <IconStopwatch />, order: 3 },
  vented_vans: { label: 'Vented', icon: <IconTruckVentilated />, order: 4 },
  blind_bol: { label: 'Blind BOL', icon: <IconEyeSlash />, order: 5 },
  maac: { label: 'MAAC', icon: <IconMAAC />, order: 6 },
  tarp: { label: 'Tarp Required', icon: <IconTarp />, order: 7 },
  dunnage: { label: 'Dunnage', icon: <IconDunnage />, order: 8 },
  team_driver: { label: 'Team Driver', icon: <IconTeamDriver />, order: 9 },
  lumper: { label: 'Lumper', icon: <IconLumper />, order: 10 },
  cfs: { label: 'CFS', icon: <IconCFS />, order: 11 },
  tsa: { label: 'TSA', icon: <IconTSA />, order: 12 },
  publish: { label: 'Publish', icon: <IconAccessorialsPublish />, order: 13 },
  pallet_jack: { label: 'Pallet Jack', icon: <IconPallet />, order: 14 },
  lift_gate: { label: 'Lift Gate', icon: <IconLiftGate />, order: 15 },
  scale_ticket: { label: 'Scale Ticket', icon: <IconTicket />, order: 16 },
  light_scale_ticket: { label: 'Light Scale Ticket', icon: <IconTicket />, order: 17 },
  heavy_scale_ticket: { label: 'Heavy Scale Ticket', icon: <IconTicket />, order: 18 },
}
